import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Modal from 'react-modal'


const TreatmentPreview = ({ isPreviewModalOpen, closePreviewModal, treatmentQuotation }) => {
    return (
        <Modal
            isOpen={isPreviewModalOpen}
            onRequestClose={closePreviewModal}
            className="preview-modal"
            overlayClassName="modal-overlay"
            contentLabel="Example Modal">
            <div className="treatment-quotation-preview">
                <Row>
                    <Column size={10}><h1>Preview</h1></Column>
                    <Column size={2} className="align-right">
                        <button onClick={closePreviewModal} className="btn btn-primary">x</button>
                    </Column>
                </Row>
                <iframe src={treatmentQuotation.treatmentLink} title="preview"/>

            </div>
        </Modal>
    )
}

TreatmentPreview.propTypes = {
    treatmentQuotation: PropTypes.object,
    isPreviewModalOpen: PropTypes.bool.isRequired,
    closePreviewModal: PropTypes.func.isRequired,
}

export default TreatmentPreview



// WEBPACK FOOTER //
// ./src/modules/treatment/component/quotation/TreatmentPreview.js